import * as angular from 'angular';

import { Helper } from '../../common';
import { WidgetBase } from '../../widgets';
import { SeriesSelectorViewModel } from '../../models';
import { ISeriesSelectorService } from '../../services';
import { SeriesSelectionWidgetConfiguration } from './seriesSelection.configuration';
import { SeriesSelectionWidgetDefinition as definition } from './seriesSelection.definition';

export class SeriesSelectionWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    guid: string;
    highlights = definition.highlights;
    icon = definition.icon;
    name = definition.title;
    row = 0;
    sizeX = 4;
    sizeY = 8;
    type = definition.type;

    constructor(private _seriesSelectorService: ISeriesSelectorService) {
        super();
        this.guid = Helper.getGuid();
        this.configuration = new SeriesSelectionWidgetConfiguration();
    }

    readData(excludeTags?: boolean): angular.IPromise<SeriesSelectorViewModel[]> {
        return this._seriesSelectorService.getSeriesSelectorViewModels(excludeTags);
    }

    readQueries(): angular.IPromise<SeriesSelectorViewModel[]> {
        return this._seriesSelectorService.getQueriesSeriesSelectorViewModels();
    }
}